import { render, staticRenderFns } from "./PolicySubmission.vue?vue&type=template&id=75a9de7b&"
import script from "./PolicySubmission.vue?vue&type=script&lang=ts&"
export * from "./PolicySubmission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports